<script>
  import { createEventDispatcher } from "svelte"
  const dispatch = createEventDispatcher()
  import ApplicationState from "../../../../../Stores/applicationStates"
  import SmallList from "./smallList.svelte"
  import LargeList from "./largeList.svelte"
  import DeleteModal from "./deleteModal.svelte"
  import notify from "../../../../../Script/notify"
  import DuplicateConfirmation from "../../../Email/Shared/duplicateConfirmation.svelte"
  import { deleteRequest, getRequest, patchRequest, postRequest } from "../../../../../Script/apiMethods"
  /**
   * @type {import("../../../../../Stores/templatesList").Item}
   */
  export let template
  export let showLoading
  export let loadingText
  export let count

  let showDeleteModal = false

  /**
   * @type {Boolean} whether to show duplicate modal or not
   */
  let showDuplicateModal = false

  const deleteTemplate = async () => {
    try {
      showDeleteModal = false
      showLoading = true
      loadingText = `Deleting ${template.name} File Design Template`

      await deleteRequest(`/api/swagger/v2/templates/files/${template.id}`, {
        headers: {
          "x-access-token": $ApplicationState.token,
        },
      })

      dispatch("fetchList")

      notify.success(`<strong style="hyphens: auto;">${template.name}</strong> deleted successfully`)
    } catch (error) {
      const info = "PAGE: File template List\nEVENT: While deleting file template"
      notify.danger(error, info)
    } finally {
      showLoading = false
    }
  }

  const duplicateTemplate = async () => {
    try {
      showLoading = true
      showDuplicateModal = false
      loadingText = `Duplicating&nbsp;<strong>${template.name} File Design Template</strong>&nbsp;`

      const CONFIG = {
        headers: {
          "x-access-token": $ApplicationState.token,
        },
      }

      // Fetch File template Data by ID
      const { template: fileData } = await getRequest(`/api/swagger/v2/templates/files/${template.id}`, CONFIG)

      // Fetching File list
      const { templates: fileTemplates } = await getRequest(`/api/swagger/v2/templates/files?limit=${count}&page=1&sort=-1&sortBy=date`, CONFIG)

      let tempArray = fileTemplates.filter((document) => document.name.includes(`${fileData.name}`))

      let copyCount = 0

      for (let i = 0; i < tempArray.length; i++) {
        if (fileData.name.length + 4 == tempArray[i].name.length) copyCount++
        // console.log(copyCount)
      }
      // console.log(copyCount)

      let tempValue = ` ${copyCount ? `(${copyCount + 1})` : `(1)`}`

      // console.log({ tempArray })

      // let tempValue = ` ${tempArray.length ? `(${tempArray.length + 1})` : `(1)`}`

      let remainingLength = 30 - tempValue.length

      // Make sure the fileData.name doesn't exceed the remaining length
      let truncatedName = fileData.name.slice(0, remainingLength)

      let templateName = truncatedName + tempValue

      let { created, modified, ...filteredData } = fileData

      let reqBody = { ...filteredData, name: templateName }

      // console.log(reqBody.document)

      let dublicateDocData = await duplicateDocTemplate(reqBody.document)

      // console.log(dublicateDocData)
      reqBody.document = dublicateDocData.id

      //for convert file
      let file = await convertIpfsToFile({ fileName: `File Design Template's File ${Date.now()}`, ipfsuri: reqBody.baseUri })

      reqBody.file = file
      delete reqBody.baseUri

      // Creating File template
      const { template: newFileTemp } = await postRequest("/api/swagger/v2/templates/files", reqBody, {
        headers: {
          "Content-Type": "multipart/form-data",
          "x-access-token": $ApplicationState.token,
        },
      })

      dublicateDocData.file = newFileTemp.id
      // console.log(dublicateDocData)

      // Updating Document template
      await patchRequest(`/api/swagger/v2/templates/documents/${dublicateDocData.id}`, dublicateDocData, CONFIG)

      dispatch("fetchList")

      notify.success(`<strong>${newFileTemp.name}</strong> created successfully.`)
    } catch (error) {
      // Show an error notification
      const info = "PAGE: File template List\nEVENT: While duplicating file template"
      notify.danger(error, info)
    } finally {
      showLoading = false
    }
  }

  const duplicateDocTemplate = async (id) => {
    try {
      const CONFIG = {
        headers: {
          "x-access-token": $ApplicationState.token,
        },
      }

      // Fetching document template by ID
      const { template: documentData } = await getRequest(`/api/swagger/v2/templates/documents/${id}`, CONFIG)
      // console.log(documentData)

      // Fetching document list
      const { templates: documentList } = await getRequest(`/api/swagger/v2/templates/documents?limit=${count}&page=1`, CONFIG)

      let tempArray = documentList.filter((document) => document.name.includes(`${documentData.name}-(1)`))

      // console.log(tempArray)

      let tempValue = `-(1)-${tempArray.length ? `(${tempArray.length + 1})` : `(1)`}`

      let remainingLength = 30 - tempValue.length

      // Make sure the documentData.name doesn't exceed the remaining length
      let truncatedName = documentData.name.slice(0, remainingLength)

      let templateName = truncatedName + tempValue

      let { created, modified, ...filteredData } = documentData

      let reqBody = { ...filteredData, name: templateName }

      reqBody.file = ""
      reqBody.email = ""

      // console.log(reqBody)

      // Creating document template
      const { template: docTemp } = await postRequest("/api/swagger/v2/templates/documents", reqBody, CONFIG)

      return docTemp
    } catch (error) {
      const info = "PAGE: File template List\nEVENT: While duplicating document template"
      // Show an error notification
      notify.danger(error, info)
    }
  }

  const convertIpfsToFile = async (file) => {
    try {
      const fileData = await getRequest(`${file.ipfsuri}`, { responseType: "blob" })

      const blobFile = new File([fileData], file.fileName, {
        type: "image/png",
      })

      return blobFile
    } catch (error) {
      throw error
    }
  }
</script>

{#if showDeleteModal}
  <DeleteModal
    on:click={() => {
      showDeleteModal = false
    }}
    {template}
    on:delete={deleteTemplate}
  />
{/if}

{#if $ApplicationState.fileListToggle}
  <div class="block">
    <SmallList
      {template}
      on:onDuplicate={() => (showDuplicateModal = true)}
      on:click={() => {
        showDeleteModal = true
      }}
    />
  </div>
{:else}
  <div class="hidden h-[250px] md:block">
    <LargeList
      {template}
      on:onDuplicate={() => (showDuplicateModal = true)}
      on:click={() => {
        showDeleteModal = true
      }}
    />
  </div>
  <div class="block md:hidden">
    <SmallList
      {template}
      on:onDuplicate={() => (showDuplicateModal = true)}
      on:click={() => {
        showDeleteModal = true
      }}
    />
  </div>
{/if}

{#if showDuplicateModal}
  <DuplicateConfirmation
    on:click={() => {
      showDuplicateModal = false
    }}
    on:duplicate={duplicateTemplate}
    templateName={template.name}
    type="File Design"
  />
{/if}
